// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Login from './Components/Login/Login';
// import Signup from './Components/Signup/Signup';
// import 'bootstrap/dist/css/bootstrap.min.css';


// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './Components/Login/Login';
// import Signup from './Components/Signup/Signup';
// import DashboardLayout from './Components/Dashboard/DashboardLayout';
// import Products from './Components/Dashboard/Products';
// import Profile from './Components/Dashboard/Profile';
// import Bids from './Components/Dashboard/Bids';
// import 'bootstrap/dist/css/bootstrap.min.css';

// function PrivateRoute({ children }) {
//   const token = localStorage.getItem('token');
//   return token ? children : <Navigate to="/login" replace />;
// }

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Public Routes (No Dashboard Layout) */}
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />

//         {/* Protected Routes with DashboardLayout */}
//         <Route
//           path="/dashboard"
//           element={
//             <PrivateRoute>
//               <DashboardLayout />
//             </PrivateRoute>
//           }
//         >
//           <Route index element={<Navigate to="products" replace />} />
//           <Route path="products" element={<Products />} />
//           <Route path="profile" element={<Profile />} />
//           <Route path="bids" element={<Bids />} />
//         </Route>

//         {/* Redirect unknown routes */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login/Login';
import Signup from './Components/Signup/Signup';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import Products from './Components/Dashboard/Products';
import Profile from './Components/Dashboard/Profile';
import Bids from './Components/Dashboard/Bids';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserTable from './Components/Dashboard/UserTable';
import AdminDashboard from './Components/Dashboard/AdminDashboard';
import Reports from './Components/Dashboard/Reports';
import MyBids from './Components/Dashboard/MyBids';
import BuyerProfile from './Components/Dashboard/BuyerProfile';
import AdminProducts from './Components/Dashboard/AdminProducts';
import ReceivedBids from './Components/Dashboard/Bids';
import BuyerConfirmedBids from './Components/Dashboard/BuyerConfirmedBids';
import SellerBidStatus from './Components/Dashboard/SellerBidStatus';
import SellerExpiredBids from './Components/Dashboard/SellerExpiredBids';
import BuyerSuccessfulBids from './Components/Dashboard/BuyerSuccessfulBids';
import SellerSuccesBids from './Components/Dashboard/SellerSuccesBids';
import UserReports from './Components/Dashboard/UserReports';
import ProductsReports from './Components/Dashboard/ProductsReports';
import BidsReports from './Components/Dashboard/BidsReports';
import SellerDashboard from './Components/Dashboard/SellerDashboard';
import BuyerDashboard from './Components/Dashboard/BuyerDashboard';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}


function DashboardIndexRedirect() {
  const user = JSON.parse(sessionStorage.getItem('user'));

  if (!user || !user.role) {
    return <Navigate to="/login" replace />;
  }

  // Redirect based on role
  switch (user.role.toLowerCase()) {
    case 'admin':
      return <Navigate to="admin-dashboard" />;
    case 'seller':
      return <Navigate to="seller-dashboard" />;
    case 'buyer':
      return <Navigate to="buyer-dashboard" />;
    default:
      return <Navigate to="/login" replace />;
  }
}


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* Protected Dashboard Routes */}
  <Route
  path="/"
  element={
    <PrivateRoute>
      <DashboardLayout />
    </PrivateRoute>
  }
>
  <Route index element={<DashboardIndexRedirect />} />
  <Route path="products" element={<Products />} />
  <Route path="profile" element={<Profile />} />
  <Route path="admin-dashboard" element={<AdminDashboard />} />
  <Route path="bids" element={<Bids />} />   
  <Route path="users" element={<UserTable />} />
  <Route path="reports" element={<Reports />} />
  <Route path="my-bids/create" element={<MyBids />} />
  <Route path="buyer-profile" element={<BuyerProfile />} />
  <Route path='admin-products' element={<AdminProducts/>}/>
  <Route path='bids/received' element={<ReceivedBids/>}/>
  <Route path='my-bids/confirm' element={<BuyerConfirmedBids/>}/>
  <Route path='bids/status' element={<SellerBidStatus/>}/>
  <Route path='seller/bids/expired' element={<SellerExpiredBids/>}/>
  <Route path='my-bids/success' element={<BuyerSuccessfulBids/>}/>
  <Route path='seller-bids/success' element={<SellerSuccesBids/>}/>
  <Route path='reports/users' element={<UserReports/>}/>
  <Route path='reports/products' element={<ProductsReports/>}/>
  <Route path='reports/bids' element={<BidsReports/>}/>
    <Route path='seller-dashboard' element={<SellerDashboard/>}/>
    <Route path='buyer-dashboard' element={<BuyerDashboard/>}/>
</Route>


        {/* Catch-All Route */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
